import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayercontrolComponent } from './layercontrol.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [LayercontrolComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [LayercontrolComponent],
})
export class LayercontrolModule { }
